import {
    GET_ASSET_ITEM_STATUS_HEADER_DETAIL,
    SET_ASSET_ITEM_STATUS_HEADER_DETAIL
} from "./AssetItemStatusHeaderDetailsType"

const getAssetItemStatusHeaderDetail = (fleetDetailId: any, currentHeaderDetail: any) => ({
    type: GET_ASSET_ITEM_STATUS_HEADER_DETAIL,
    fleetDetailId,
    currentHeaderDetail
})

const setAssetItemStatusHeaderDetail = (assetItemStatusHeaderDetail: any) => ({
    type: SET_ASSET_ITEM_STATUS_HEADER_DETAIL,
    assetItemStatusHeaderDetail: assetItemStatusHeaderDetail
})

export {
    getAssetItemStatusHeaderDetail,
    setAssetItemStatusHeaderDetail
}